"use strict";
/**
 * This module is used for saving which element has focus so that
 * focus can be restored at a later point in time. This is useful
 * for components such as Modals.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreFocus = exports.saveFocus = void 0;
var element = null;
var saveFocus = function (elem) {
    element = elem ? elem : document.activeElement;
};
exports.saveFocus = saveFocus;
var restoreFocus = function (clear) {
    if (clear === void 0) { clear = true; }
    if (!element) {
        return;
    }
    element.focus();
    if (clear) {
        element = null;
    }
};
exports.restoreFocus = restoreFocus;
